import { useEffect, useState } from "react"
import { useLanguage } from "@/contexts/LanguageContext"

interface StatItemProps {
  target: number
  suffix: string
  label: string
}

const StatItem = ({ target, suffix, label }: StatItemProps) => {
  // Afficher directement les valeurs sans animation de compteur

  return (
    <div className="text-center scroll-reveal card-modern p-8 rounded-2xl">
      <div className="text-6xl md:text-7xl font-black text-gradient mb-4 counter">
        {target}{suffix}
      </div>
      <div className="text-lg md:text-xl font-semibold text-muted-foreground">
        {label}
      </div>
    </div>
  )
}

const StatsSection = () => {
  const { t } = useLanguage()
  
  const stats = [
    { target: 100, suffix: "+", label: t('stats.students') },
    { target: 9, suffix: "", label: t('stats.domains') },
    { target: 72, suffix: "h", label: t('stats.contact') }
  ]

  return (
    <section id="stats" className="py-24 bg-gradient-accent relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-section-title text-je-black mb-4">
            {t('stats.title')}
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('stats.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {stats.map((stat, index) => (
            <StatItem
              key={index}
              target={stat.target}
              suffix={stat.suffix}
              label={stat.label}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default StatsSection